import serverCall from "../serverCall";

const getMapLimitConfig = async () => {
  try {
    const response = await serverCall.get("admin/job/limit-config");
    return response;
  } catch (error) {
    throw error;
  }
};

const updateMapLimitConfig = async (body) => {
  try {
    const response = await serverCall.post("admin/job/limit-config", body);
    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  getMapLimitConfig,
  updateMapLimitConfig,
};
